export default "__VITE_ASSET__UXwGsAc4__"